import { render, staticRenderFns } from "./dialog-confirmcancelusersharefile.vue?vue&type=template&id=cbe10a94&"
import script from "./dialog-confirmcancelusersharefile.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmcancelusersharefile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports